import { render } from "./ReleaseNotes.vue?vue&type=template&id=2b1a29c0"
import script from "./ReleaseNotes.vue?vue&type=script&lang=js"
export * from "./ReleaseNotes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__